import { render, staticRenderFns } from "./v-switch.vue?vue&type=template&id=f1b28956"
import script from "./v-switch.vue?vue&type=script&lang=js"
export * from "./v-switch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1b28956')) {
      api.createRecord('f1b28956', component.options)
    } else {
      api.reload('f1b28956', component.options)
    }
    module.hot.accept("./v-switch.vue?vue&type=template&id=f1b28956", function () {
      api.rerender('f1b28956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/components/switch/v-switch.vue"
export default component.exports